<template>
  <div v-if="visible" class="window relative">
    <div v-if="modal" class="modal-overlay fixed w-screen h-screen z-40 top-0 left-0 bg-gray-200 bg-opacity-50"></div>
    <div class="wrapper fixed top-0 rounded-md shadow-xl overflow-auto h-screen w-full lg:w-3/4 z-50 bg-white border border-solid border-gray-400">
      <div class="header flex items-center relative h-12 leading-5 pl-10 pr-10 border-b-2 border-gray-300 md:h-10 md:leading-10 md:pl-5 md:pr-5">
        <div class="title pull-left">{{ title }}</div>
        <div class="top-buttons absolute right-0 mr-3">
          <div class="close-btn cursor-pointer font-extrabold text-gray-500 p-1 leading-3 border border-solid border-gray-400 rounded" @click="close">X</div>
        </div>
      </div>
      <div class="content min-h-full">
        <slot name="content"></slot>
      </div>
      <div v-if="!noFooter" class="footer flex items-center justify-end relative h-16 leading-16 pl-3 pr-3 border-t-2 border-gray-300">
          <my-button v-if="!$slots['buttons']" class="bg-gray-300 hover:bg-gray-400" @click="close">Close</my-button>
        <slot name="buttons"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "window",
  props: {
    modal: {type: Boolean, default: false},
    noFooter: {type: Boolean, default: false},
    visible: {type: Boolean, default: false},
    title: {type: String, default: ''}
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
      this.$emit('onclose', false);
    }
  }
}
</script>

<style scoped>

</style>